import jwtInterceptor from '/src/shared/jwtInterceptor'

const apiUrl = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH;

export class AppApi
{

  static async getCustomerGroups()
  {
    const url = apiUrl + 'getCustomerGroups';
    var response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }
  static async getAllProductBrandsForSelect()
  {
    let url = apiUrl + 'ProductBrand/getForSelect';
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }
  static async getAllProductCategoryForSelect()
  {
    let url = apiUrl + 'ProductCategory/getForSelect';
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }
  static async getAllVisitorsForSelect()
  {
    let url = apiUrl + 'Message/getAllVisitors';
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }
  static async deleteMessage(id)
  {
    let url = apiUrl + 'Message/delete/'+id
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
  }

  static async getCustomerVisitForm(id)
  {
    let url = apiUrl + 'CustomerVisitForm/Get/'+id
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }
}